module.exports = __webpack_public_path__ + "static/media/capy_page_area02_img_en@2x.61a6584b.png";